module.exports = __webpack_public_path__ + "img/Screen Shot 2021-01-22 at 6.18.30 PM@2x.89ea1a0d.png";